<script>
  import { titleCase } from '../lib/text.js';

  export let order = null;

  $: address = order && order.shippingAddress;
  $: customer = order && order.customer;
  $: name = titleCase(
    (address && (address.name || [address.firstName, address.lastName].filter(Boolean).join(' '))) ||
    (customer && [customer.firstName, customer.lastName].filter(Boolean).join(' ')) ||
    ''
  );
  $: orderDate = order && order.createdAt
    ? new Date(order.createdAt).toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' })
    : '';
  $: items = (order && order.lineItems) || [];
</script>

<div class="slip">
  <div class="head">
    <div class="brand">
      <img src="/images/logo-hero.png" alt="CardHero" />
      <span>CardHero.com</span>
    </div>
    <div class="meta">
      <div class="doc">Packing Slip</div>
      <div>{order ? order.name : ''}</div>
      {#if orderDate}<div>{orderDate}</div>{/if}
    </div>
  </div>

  {#if address}
    <div class="addr">
      <strong>{name}</strong>
      {#if address.company}<div>{address.company}</div>{/if}
      <div>{address.address1}</div>
      {#if address.address2}<div>{address.address2}</div>{/if}
      <div>{address.city}{#if address.province}, {address.province}{/if}</div>
      <div>{address.zip} · {address.country}</div>
    </div>
  {/if}

  <table class="items">
    <thead>
      <tr><th class="q">Qty</th><th>Item</th></tr>
    </thead>
    <tbody>
      {#each items as it (it.id)}
        <tr>
          <td class="q">{it.quantity}</td>
          <td>
            {it.title}
            {#if it.variantTitle && it.variantTitle !== 'Default Title'}<span class="variant"> — {it.variantTitle}</span>{/if}
          </td>
        </tr>
      {/each}
    </tbody>
  </table>

  <div class="thanks">Thank you for your order ♥</div>
</div>

<style>
  /* Same 100 x 148 mm stock as the shipping label — content sits at the top
     so the blank remainder can be trimmed for neatness. */
  .slip {
    width: 100mm;
    height: 148mm;
    box-sizing: border-box;
    padding: 4mm 8mm 8mm;
    background: #fff;
    border: 1px solid #ccc;
    display: flex;
    flex-direction: column;
    color: #000;
  }
  .head {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    border-bottom: 0.4mm solid #000;
    padding-bottom: 2.5mm;
  }
  .brand img { height: 14mm; width: auto; display: block; }
  .brand span { display: block; text-align: center; margin-top: 0.5mm; font-size: 8pt; font-weight: 700; }
  .meta { text-align: right; font-size: 9pt; line-height: 1.4; color: #333; }
  .meta .doc { font-size: 11pt; font-weight: 700; color: #000; }

  .addr { margin-top: 3mm; font-size: 10pt; line-height: 1.4; }
  .addr strong { display: block; }

  .items { margin-top: 3.5mm; width: 100%; border-collapse: collapse; font-size: 9.5pt; }
  .items th { text-align: left; font-size: 8pt; text-transform: uppercase; letter-spacing: 0.04em; color: #555; border-bottom: 0.3mm solid #999; padding: 0 0 1mm; }
  .items td { padding: 1.2mm 0; border-bottom: 0.2mm solid #ddd; vertical-align: top; }
  .items .q { width: 8mm; font-weight: 700; padding-right: 2mm; }
  .items .variant { color: #555; }

  .thanks { margin-top: 3.5mm; font-size: 9pt; text-align: center; color: #333; }

  @media print {
    /* @page margin provides the border; let height collapse so the slip
       hugs the top-left of the A4 sheet and the rest trims off. */
    .slip { border: none; height: auto; padding: 0; page-break-after: always; break-after: page; }
    .slip:last-child { page-break-after: auto; break-after: auto; }
  }
</style>
